module.exports = __webpack_public_path__ + "img/KE.8564397b.svg";